import {useTranslation} from "react-i18next";
import {setTrack} from "utils";
import {Bottom} from "../Bottom";
import React from "react";

export function FooterPaywall() {
  const {t} = useTranslation('common', {keyPrefix: 'footer'})

  return (
    <Bottom className={'gap-5'} footer={false}>
      <hr/>
      <div className={'w-100'}>
        <img className={'d-block mb-4'} src={'/static/img/logo-150.png'} loading={'lazy'} width={150} height={36} alt={'logo'}/>
        <div className={'row gap-5 small fw-bold'}>
          <a rel="noreferrer" target={'_blank'} className={'row w-auto gap-2'} style={{color: '#B5BDCC'}}
             onClick={() => setTrack('paywall_cta_youtube_click')}
             href={'https://www.youtube.com/channel/UCnSzrXMpvNd7wMGue5Uty3A?sub_confirmation=1'}>
            <img src={'/static/img/icon/youtube.svg'} loading={'lazy'} width={20} height={20} alt={'Youtube'}/>
            115K
          </a>
          <a rel="noreferrer" target={'_blank'} className={'row w-auto gap-2'} style={{color: '#B5BDCC'}}
             onClick={() => setTrack('paywall_cta_instagram_click')}
             href={'https://www.instagram.com/vocalimage.app/'}>
            <img src={'/static/img/icon/instagram.svg'} loading={'lazy'} width={16} height={16} alt={'Instagram'}/>
            69K
          </a>
          <a rel="noreferrer" target={'_blank'} className={'row w-auto gap-2'} style={{color: '#B5BDCC'}}
             onClick={() => setTrack('paywall_cta_tiktok_click')}
             href={'https://www.tiktok.com/@vocalimage'}>
            <img src={'/static/img/icon/tiktok.svg'} loading={'lazy'} width={16} height={16} alt={'TikTok'}/>
            20K
          </a>
        </div>
      </div>
      <footer className={'note md fw-400 text-start'}>
        <div className={'stack mb-4'} style={{gap: 4}}>
          <p>© 2021-2025 Vocal Image</p>
          <p>99 Wall St #2512, New York, NY, USA, 10005</p>
          <p>+19178094487</p>
        </div>

        <p className={'mb-1'}>{t('text')}</p>
        <p className={'mb-1'}>
          <a rel="noreferrer" target={'_blank'} href={process.env.REACT_APP_WEB_LINK + 'terms'}
             className={'link nowrap'}>{t('terms-conditions')}</a>
          <i className={'circle B'}/>
          <a rel="noreferrer" target={'_blank'} href={process.env.REACT_APP_WEB_LINK + 'privacy'}
             className={'link nowrap'}>{t('privacy-policy')}</a>
          <i className={'circle B'}/>
          <a rel="noreferrer" target={'_blank'} href={process.env.REACT_APP_WEB_LINK + 'subscription'}
             className={'link nowrap'}>{t('subscription-policy')}</a>
        </p>
        <p className={'mb-1'}>
          <a rel="noreferrer" target={'_blank'} className={'link nowrap'}
             onClick={() => setTrack('paywall_cta_contact_support_click')}
             href={'https://help.vocalimage.app/hc/en-us/requests/new'}>{t('support')}</a>
        </p>
      </footer>
    </Bottom>
  )
}